import React from 'react';

const Header = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark fixed-top">
      <div className="container">
        <a className="navbar-brand" href="#hero">
          <img src={process.env.PUBLIC_URL + '/logoESDA.png'} alt="LactiGo Logo" className="navbar-logo" />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a className="nav-link" href="#features">Beneficios</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#video">Video</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#testimonials">Testimonios</a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#gallery">Galería</a>
            </li>
            <li className="nav-item">
              <a className="nav-link btn btn-primary ms-lg-3" href="https://my.lactigo.com/dannyvargasinternacional" target="_blank" rel="noopener noreferrer">Comprar Ahora</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;